import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    SearchParams: {},
    hotels: [],
    onceSubmit: false,
    currency: localStorage.getItem('currency') || 'MOP',
    dataLayerReady: false,
    gaData: {
      transactionId: '',
      transactionTotal: '',
      transactionTax: '',
      transactionProducts: '',
      currentTimeMacau: localStorage.date || '',
      currentTimeLocal: '',
      checkInDate: '',
      checkOutDate: '',
      selectedHotel: '',
      memberLoggedIn: false,
      numberTotalRooms: '',
      numberTotalAdults: '',
      numberTotalChild: '',
      numberTotalNights: '',
      pointsUsed: '',
      paymentMethod: '',
      currentStep: '',
      cookieId: '',
      skinCode: '',
      placeOfResidence: '',
    }
  },
  mutations: {
    stateChange(state, payload) {
      state[payload.k] = payload.v
    },
  },
  getters: {
    currencyIcon: state => {
      const obj = {
        USD: '$',
        MOP: '$',
        CNY: '¥',
        HKD: '$',
        JPY: '￥',
        KRW: '₩',
      }
      return obj[state.currency]
    }
  },
  actions: {},
  modules: {}
})
